// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"horizontal-scroll_scrollWrapper__Pogap","scroll":"horizontal-scroll_scroll__uyl72"};